<template>
    <div id="rank">

        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">排行</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="fl">
            <div :class="{active : rank == 1}" @click="rank = 1;page=1;booklist=[];getBookList()"><p>畅销榜</p></div>
            <div :class="{active : rank == 2}" @click="rank = 2;page=1;booklist=[];getBookList()"><p>打赏榜</p></div>
            <div :class="{active : rank == 3}" @click="rank = 3;page=1;booklist=[];getBookList()"><p>点击榜</p></div>
        </div>
        <div class="fr">
            <ul v-infinite-scroll="getBookList">
                <router-link v-for="item,key in booklist" tag="li" :to="{name:'Book',params:{wid:item.wid}}">

                    <span class="finish"><img :src="require('./../assets/images/finish' + item.is_finish +'.png')" alt=""></span>
                    <el-image :src="'http://static.yuread.cn/' + item.h_cover + '@!thumb'" fit="fit" lazy></el-image>
                    <div>
                        <p class="title">{{item.title}}</p>
                        <p class="description">{{item.sort_description}}</p>
                        <p class="author">{{item.author}}</p>
                    </div>
                    <span class="no" v-if="key < 3"><img :src="require('./../assets/images/no'+(key+1)+'.png')" alt=""></span>
                    <span class="no" v-if="key >2">{{key+1}}</span>
                </router-link>

            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Rank",
        data(){
            return {
                rank:1,
                page : 1,
                limit : 20,
                booklist : [],
            }
        },
        methods : {
            getBookList(){
                this.axios.post('/api/rank/getRanklist',{
                    rank : this.rank,
                    page : this.page,
                    limit : this.limit
                }).then(r => {
                    let data = r.data.data.data;
                    this.page++;
                    data.forEach(v =>{
                        this.booklist.push(v);
                    })
                })
            }
        },
        created(){
        }
    }
</script>

<style lang="less">
    #rank{background: #f6f6f7;overflow: hidden;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .fl{width:146px;
            div{width:100%;height:145px;padding: 45px 0;text-align: center;font-size: 30px;}
            div.active{background: #fff;
                p{border-left: 5px solid @theme;color: @theme;}
            }
        }
        .fr{width:calc(100% - 146px);height:calc(100% - 100px);min-height: 500px;background: #fff;
            ul{padding: 20px;overflow: auto;height: 100%;
                li{overflow: auto;border-bottom: 1px solid #efefef;padding: 10px 0;position:relative;
                    .el-image{width:120px;height: 160px;float: left;box-shadow: 0 1px 3px rgba(0,0,0,.3);padding: 0;
                        img{width: 100%;height: 100%;}

                    }
                    div{float: left;width:440px; padding-left: 20px;
                        p{padding: 5px 0;}
                        .title{font-size: 28px;color: #272727;}
                        .description{color:#666;font-size: 24px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
                        .author{color:#b0b0b0;font-size: 24px;}
                    }
                    .no{position:absolute;top:0px;right:20px;text-align: center;color: #666;width:50px;
                        img{width:60px;height:60px;box-shadow: none;}
                    }
                    .finish{width:60px;height:60px;position: absolute;top:6px;left:-1px;z-index: 999;
                        img{width:100%;height:100%;box-shadow: none;}
                    }
                }
            }
        }
    }
</style>
